/* eslint-disable react/prop-types */
import "./KeyExperience.css";

export default function KeyExperience(props) {
  return <div className="key-experience">{props.name}</div>;
}
